/**
 * Pixel width helpers for a column grid with a fixed gap between columns (same idea as CSS `column-gap` / `--grid-gap`).
 * Use the same gap as in branding: `GRID_GAP_PX` from `config/branding/grid`, or the value behind `var(--grid-gap)`.
 */

/**
 * Width of a **single** column (px).
 * You pass: full row width, gap between columns, and how many columns the row is split into.
 * Returns `0` if width or column count is invalid.
 */
export const columnWidthPx = (containerWidthPx: number, gapPx: number, cols: number): number => {
    if (containerWidthPx <= 0 || cols < 1) {
        return 0;
    }
    return (containerWidthPx - (cols - 1) * gapPx) / cols;
};

/**
 * Total width (px) when a block spans **several** columns (e.g. 9 of 12).
 * You pass: how many columns to span, one column’s width (`colW`), and the gap.
 * Returns `0` if inputs are invalid (e.g. no column width).
 */
export const spanWidthPx = (spanCols: number, colW: number, gapPx: number): number => {
    if (spanCols < 1 || colW <= 0) {
        return 0;
    }
    return spanCols * colW + (spanCols - 1) * gapPx;
};

/**
 * Image **height** (px) for a **4:5** product image when you only know the **width** (same ratio as PLP narrow cards).
 * Result is rounded to whole pixels.
 */
export const imageHeightFromSpanWidthPx = (spanWidthPx: number): number => Math.round((spanWidthPx * 5) / 4);
